import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {Notification} from '@models/header/notification';

@Component({
    selector: 'scitis-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
    standalone: false
})
export class NotificationModalComponent {

  @Input()
  notification: Notification = new Notification();

  closeButtonText: string = '';

  constructor(private activeModal: NgbActiveModal,
              private translateService: TranslateService) {
    this.closeButtonText = this.translateService.instant('Close notification');
  }

  onClose() {
    this.activeModal.close(this.notification);
  }

}
